export default "__VITE_ASSET__B8m98MVH__"